import type { AttachmentsPerKey } from './AttachmentsPerKey';

export const defaultStateContextPerKey: AttachmentsPerKey = {
	attachments: new Map(),
};
